/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 10/10/2023
 */

import { Button, Grid, InputAdornment, TextField, Typography, styled } from '@mui/material'
import React, { useEffect } from 'react'
import Styles from "./ContactForm.module.css";
import image from "../../Assets/house.png";
import { Send } from '@mui/icons-material';
import { FileUploader } from './FileUploader';
import { useState } from 'react';
import Success from './Success';
import { useGetAllAdminEmailsQuery } from '../../Store/Services/EmailService';

const FormField = styled(TextField)({
    '& label.Mui-focused': {
      color: '#9747FF',
      fontSize: '1.25rem'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#9747FF',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#9747FF',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#9747FF',
      },
      '&:hover fieldset': {
        borderColor: '#9747FF',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#9747FF',
      },
    },
    '& .MuiInputLabel-root': {
        color: '#9747FF'
    }
});

const ContactForm = () => {

  const [data, setData] = useState({})
  const [open, setOpen] = useState(false)

  const {
    data: emailList,
    isSuccess,
  } = useGetAllAdminEmailsQuery();

  useEffect(() => {
    const setEmails = () => {
      if(isSuccess){
        setData({
          adminEmails: emailList?.to
        })
      }
    }
    setEmails()
  }, [emailList])

  const onFileUpload = (base64, file) => {
    setData({...data, attachment: base64, attachmentName: file?.name, attachmentType: file?.type})
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    fetch('https://issueproxy.server.fouroots.com/n_ach/issue_api/v1/issues', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    })
       .then((response) => response.json())
       .then((data) => {
          console.log('response' ,data);
          setOpen(true)
       })
       .catch((err) => {
          console.log(err.message);
       });
  }

    return (
      <div>
        <div className={Styles.outerContainer}>
            <Grid container>
                <Grid item xs={12} md={11} className={Styles.textContainer}>
                <div className={Styles.formContainer}>
                    <Typography className={Styles.formHeading}>
                        Let&apos;s discuss on something cool together
                    </Typography>
                    <form onSubmit={handleSubmit}>
                        <FormField onChange={e => setData({...data, requesterName: e.target.value})} className={Styles.formInput} fullWidth label="Your name" variant="standard" required />
                        <FormField onChange={e => setData({...data, email: e.target.value})} className={Styles.formInput} fullWidth label="Your email" variant="standard" required />
                        <FormField 
                        onChange={e => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {  
                            setData({...data, mobileNumber: value});
                          }
                        }} 
                        helperText={data.mobileNumber && data.mobileNumber.length < 10 ? "Please enter a valid 10-digit phone number" : ""}
                        error={data.mobileNumber && data.mobileNumber.length < 10}
                        className={Styles.formInput} 
                        fullWidth 
                        label="Your mobile number" 
                        type='number' 
                        variant="standard" 
                        required 
                      />
                        <FormField onChange={e => setData({...data, message: e.target.value})} className={Styles.formInput} fullWidth label="Your message" variant="standard" required />
                        <FormField className={Styles.formInput} fullWidth label="Attachment" variant="standard" value={""}
                            InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FileUploader handleFile={(a, b) => onFileUpload(a, b)} />
                                  </InputAdornment>
                                ),
                            }}
                        />
                        {/* <img className={Styles.imageMobile} src={image} alt="Contact" /> */}
                        <Button type='submit' variant='contained' className={Styles.button}><Send className={Styles.bottonIcon} /> Send Message</Button>
                    </form>
                </div>
                </Grid>
            </Grid>
        </div>
        <Success 
          open={open} 
          onClose={() => {
            setOpen(false)
            window.location.reload()
          }}
        />
      </div>
    )
}

export default ContactForm